import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import SectionOneImage from "../../assets/Icons/SectionOneImage.svg";
import SimpleButton from "components/SimpleButton";
import useDemoPageStyles from "./styles";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import { size } from "lodash";
import { TourContext } from "contexts/TourContext";
import ProfitIcon from "../../assets/Profitability/ProfitIcon.svg";
import CatalogHealthLogo from "../../assets/SectionThree/Logo.svg";
import CatalogHealthImage from "../../assets/SectionThree/Image.svg";
import SupplyChainImage from "../../assets/SupplyChain/Image.svg";
import SupplyChainLogo from "../../assets/SupplyChain/Logo.svg";
import BussinessGrowthImage from "../../assets/BussinessGrowth/Image.svg";
import BussinessGrowthLogo from "../../assets/BussinessGrowth/Logo.svg";
import SellerAccountImage from "../../assets/AmazonSellerAccounts/Image.svg";
import SellerAccountLogo from "../../assets/AmazonSellerAccounts/Logo.svg";
import { useIntl } from "react-intl";
import I18nKey from "translations/I18nKey";
import { TourSteps } from "types";
import Trophy from "../../assets/Achievements/trophy.svg";
import ProductsBox from "pages/Login/components/ProductsBox";
import ReactPlayer from "react-player";
import PlayButton from "../../assets/Icons/PlayButton/playButton.svg";
import ThumbNail from "../../assets/Icons/VideoThumbNail/Thumbnail.png";
import { ScrollOptions } from "pages/LandingPageHeader/types";
import VideoPlayer from "components/ReactPlayer";
import { CURRENT_ENVIRONMENT, environments } from "constants/constants";
import ReactGA from "react-ga4";

function LandingPageMainSection() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const classes = useDemoPageStyles();
  const navigate = useNavigate();
  const intl = useIntl();
  const { handleOpenSignUpModal, handleTourOpen, handleTourStepsChange } =
    useContext(TourContext);
  const { scrollTo, setScrollTo } = useContext(TourContext);

  const togglePlaying = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setPlaying((prevState) => !prevState);
  };
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const section = document.getElementById(scrollTo);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, [scrollTo]);

  const handleSignUp = () => {
    handleOpenSignUpModal(true);
    // Track the event when the signup button is clicked for prod env.
    if (CURRENT_ENVIRONMENT === environments.PRODUCTION) {
      ReactGA.event({
        category: "User",
        action: "Signup Click",
        // label:
        //   user?.user?.companyId !== ridgeWoodId ? "Non ridgewood" : "Ridgewood",
      });
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
          <Box className={classNames(classes.mainBox)}>
            <Grid
              container
              className={classNames(classes.mainGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                sm={12}
                xl={6}
                md={6}
                lg={6}
                className={classNames(classes.mainGridSectionOne, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box className={classNames(classes.sectionOneText)}>
                  <Typography
                    className={classNames(classes.amazonSellerAccounts, {
                      mobile: isMobile,
                    })}
                  >
                    {" "}
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_MANAGE,
                    })}
                    <span className={classNames(classes.wordBold)}>
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_ALL,
                      })}
                    </span>{" "}
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_SELLER_ACCOUNT,
                    })}{" "}
                    <span className={classNames(classes.wordBold)}>
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_ONE_TOOL,
                      })}
                    </span>
                  </Typography>
                  <Typography className={classNames(classes.ridgewoodSeller)}>
                    <span className={classNames(classes.exploreText)}>
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_EXPLORE,
                      })}
                    </span>

                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_EACH_TOOL,
                    })}
                  </Typography>
                </Box>
                <Box className={classNames(classes.buttonsHolder)}>
                  <SimpleButton
                    primary
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_SIGNUP,
                    })}
                    onClick={handleSignUp}
                    className={classNames(classes.signUpBtn, {
                      mobile: isMobile,
                    })}
                  />
                  <SimpleButton
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_TRY_APP,
                    })}
                    onClick={() => {
                      navigate(ROUTES.Landing);
                    }}
                    className={classNames(classes.loginBtn, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                xl={6}
                sm={12}
                className={classNames(classes.sectionOneGrid, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <img
                  src={SectionOneImage}
                  alt="Seller Image"
                  className={classNames(classes.sectionOneImage, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
            </Grid>
            <Grid
              xs={12}
              lg={12}
              md={12}
              xl={12}
              sm={12}
              className={classNames(classes.sectionOneFooterGrid)}
            >
              <Typography
                className={classNames(classes.sectionOneFooterText, {
                  mobile: isMobile,
                })}
              >
                {""}
                {intl.formatMessage({
                  id: I18nKey.LANDING_PAGE_MAIN_SECTION_APP_BUILT,
                })}
                <span
                  className={classNames(classes.sectionOneFooterTextBreak, {
                    mobile: isMobile,
                  })}
                >
                  {" "}
                  {intl.formatMessage({
                    id: I18nKey.LANDING_PAGE_MAIN_SECTION_FORMER,
                  })}
                </span>
              </Typography>
            </Grid>
            <Box
              id={ScrollOptions.DEMO_VIDEO}
              className={classNames(classes.demoVideoBox, {
                mobile: isMobile,
              })}
            ></Box>
            <Grid
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
              container
              className={classNames(classes.videoOuterGrid, {
                mobile: isMobile,
              })}
            >
              <Grid xs={0.5}></Grid>
              <Grid
                xs={11}
                className={classNames(classes.videoMainGrid, {
                  mobile: isMobile,
                })}
              >
                <VideoPlayer
                  url="videos/ridgewood.mp4"
                  playing={playing}
                  loop
                  onClick={togglePlaying}
                  playIcon={PlayButton}
                  thumbNailIcon={ThumbNail}
                  controls
                  videoClassName={classNames(classes.video, {
                    mobile: isMobile,
                  })}
                  iconClassName={classNames(classes.playBtn, {
                    mobile: isMobile,
                  })}
                  thumbnailClassName={classNames(classes.thumbnail, {
                    mobile: isMobile,
                  })}
                ></VideoPlayer>
              </Grid>
              <Grid xs={0.5}></Grid>
            </Grid>
            <Grid
              container
              className={classNames(classes.profitGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                {" "}
                <img
                  src={ProfitIcon}
                  alt="Profit Icon"
                  className={classNames(classes.profitIcon, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                xl={12}
                sm={12}
                className={classNames(classes.profitGridStyle, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Typography
                  className={classNames(classes.profitTextIncrease, {
                    mobile: isMobile,
                  })}
                >
                  {""}
                  {intl.formatMessage({
                    id: I18nKey.LANDING_PAGE_MAIN_SECTION_PROFITABILITY,
                  })}
                  <span
                    className={classNames(classes.profitTextTasks, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_TASKS,
                    })}
                  </span>
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              id={ScrollOptions.CATALOG_HEALTH}
              className={classNames(classes.catalogGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                sm={12}
                xl={5}
                md={5}
                lg={5}
                className={classNames(classes.catalogGridHolder, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box
                  className={classNames(classes.catalogHolder, {
                    mobile: isMobile,
                  })}
                >
                  <img
                    src={CatalogHealthLogo}
                    alt="Catalog Health Logo"
                    className={classNames(classes.catalogHealthLogo, {
                      mobile: isMobile,
                    })}
                  />
                  <Typography
                    className={classNames(classes.catalogTextImprove, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_IMPROVE,
                    })}
                    <span
                      className={classNames(classes.catalogTextHealth, {
                        mobile: isMobile,
                      })}
                    >
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_HEALTH,
                      })}
                    </span>
                    <span
                      className={classNames(classes.catalogTextFlag, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_FLAG,
                      })}
                    </span>
                  </Typography>
                  <SimpleButton
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_SEE_DEMO,
                    })}
                    onClick={() => {
                      navigate(ROUTES.Landing);
                      if (!isMobile) {
                        handleTourStepsChange(TourSteps.CATALOG);
                        handleTourOpen(0);
                      }
                    }}
                    className={classNames(classes.seeDemo, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                md={7}
                lg={7}
                xl={7}
                sm={12}
                className={classNames(classes.catalogHealthImage, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <img
                  src={CatalogHealthImage}
                  alt="CatalogHealth"
                  className={classNames(classes.catalogHealthImageStyles, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
            </Grid>
            <Grid
              id={ScrollOptions.SUPPLY_CHAIN}
              container
              className={classNames(classes.supplyChainGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                md={7}
                lg={7}
                xl={7}
                sm={12}
                className={classNames(classes.supplyChainImage, {
                  mobile: isMobile,
                })}
              >
                <img
                  src={SupplyChainImage}
                  alt="SupplyChain"
                  className={classNames(classes.catalogHealthImageStyles, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                xl={5}
                md={5}
                lg={5}
                className={classNames(classes.catalogGridHolder, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box
                  className={classNames(classes.supplyChainHolder, {
                    mobile: isMobile,
                  })}
                >
                  <img
                    src={SupplyChainLogo}
                    alt="SupplyChain"
                    className={classNames(classes.catalogHealthLogo, {
                      mobile: isMobile,
                    })}
                  />
                  <Typography
                    className={classNames(classes.catalogTextImprove, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_STREAMLINE,
                    })}
                    <span
                      className={classNames(classes.catalogTextHealth, {
                        mobile: isMobile,
                      })}
                    >
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_SUPPLY_CHAIN,
                      })}
                    </span>
                    <span
                      className={classNames(classes.catalogTextFlag, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_SUPPLY_ANALYZE,
                      })}
                    </span>
                  </Typography>
                  <SimpleButton
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_SEE_DEMO,
                    })}
                    onClick={() => {
                      navigate(ROUTES.Landing);
                      if (!isMobile) {
                        handleTourStepsChange(TourSteps.SUPPLY_CHAIN);
                        handleTourOpen(0);
                      }
                    }}
                    className={classNames(classes.seeDemo, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              id={ScrollOptions.BUSSINESS_GROWTH}
              container
              className={classNames(classes.catalogGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                sm={12}
                xl={5}
                md={5}
                lg={5}
                className={classNames(classes.catalogGridHolder, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box
                  className={classNames(classes.bussinessGrowth, {
                    mobile: isMobile,
                  })}
                >
                  <img
                    src={BussinessGrowthLogo}
                    alt="SupplyChain"
                    className={classNames(classes.catalogHealthLogo, {
                      mobile: isMobile,
                    })}
                  />
                  <Typography
                    className={classNames(classes.catalogTextImprove, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_MANAGE,
                    })}
                    <span
                      className={classNames(classes.catalogTextHealth, {
                        mobile: isMobile,
                      })}
                    >
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_BUSSINESS,
                      })}
                    </span>
                    <span
                      className={classNames(classes.catalogTextFlag, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_REVIEW,
                      })}
                    </span>
                  </Typography>
                  <SimpleButton
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_SEE_DEMO,
                    })}
                    onClick={() => {
                      navigate(ROUTES.Landing);
                      if (!isMobile) {
                        handleTourStepsChange(TourSteps.BUSINESS);
                        handleTourOpen(0);
                      }
                    }}
                    className={classNames(classes.seeDemo, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                md={7}
                lg={7}
                xl={7}
                sm={12}
                className={classNames(classes.bussinessGrowthImage, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <img
                  src={BussinessGrowthImage}
                  alt="BussinessGrowth"
                  className={classNames(classes.catalogHealthImageStyles, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
            </Grid>
            <Grid
              id={ScrollOptions.SELLER_ACCOUNTS}
              container
              className={classNames(classes.supplyChainGrid, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                md={7}
                lg={7}
                xl={7}
                sm={12}
                className={classNames(classes.sellerAccountImage, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <img
                  src={SellerAccountImage}
                  alt="SellerAccount"
                  className={classNames(classes.catalogHealthImageStyles, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                xl={5}
                md={5}
                lg={5}
                className={classNames(classes.catalogGridHolder, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box
                  className={classNames(classes.sellerAccountHolder, {
                    mobile: isMobile,
                  })}
                >
                  <img
                    src={SellerAccountLogo}
                    alt="SellerAccount"
                    className={classNames(classes.catalogHealthLogo, {
                      mobile: isMobile,
                    })}
                  />
                  <Typography
                    className={classNames(classes.catalogTextImprove, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_CONNECT,
                    })}
                    <span
                      className={classNames(classes.catalogTextHealth, {
                        mobile: isMobile,
                      })}
                    >
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_SELLER_ACCOUNTS,
                      })}
                    </span>
                    <span
                      className={classNames(classes.catalogTextFlag, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_SECTION_SELLERS,
                      })}
                    </span>
                  </Typography>
                  <SimpleButton
                    primary
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_GET_STARTED,
                    })}
                    onClick={handleSignUp}
                    className={classNames(classes.getStarted, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              className={classNames(classes.amazonRankSales, {
                mobile: isMobile,
              })}
              item
              xs={12}
              sm={12}
              xl={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                xs={12}
                md={7}
                lg={7}
                xl={7}
                sm={12}
                className={classNames(classes.sellerAccountImage, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <img
                  src={Trophy}
                  alt="SellerAccount"
                  className={classNames(classes.trophyStyle, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                xl={5}
                md={5}
                lg={5}
                className={classNames(classes.catalogGridHolder, {
                  mobile: isMobile,
                })}
              >
                {" "}
                <Box
                  className={classNames(classes.sellerAccountHolder, {
                    mobile: isMobile,
                  })}
                >
                  <Typography
                    className={classNames(classes.amazonRankSalesText, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_GET_ACHIEVE,
                    })}
                    <span
                      className={classNames(classes.amazonRankSalesTextSeller, {
                        mobile: isMobile,
                      })}
                    >
                      {" "}
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_GET_SELLER_APP,
                      })}
                    </span>
                    <span
                      className={classNames(classes.amazonRankSalesTextTools, {
                        mobile: isMobile,
                      })}
                    >
                      {intl.formatMessage({
                        id: I18nKey.LANDING_PAGE_MAIN_GET_OUR_TOOLS,
                      })}
                    </span>
                  </Typography>
                  <SimpleButton
                    primary
                    text={intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_TRY_APP,
                    })}
                    onClick={() => {
                      navigate(ROUTES.Landing);
                    }}
                    className={classNames(classes.tryButton, {
                      mobile: isMobile,
                    })}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid className={classNames(classes.greyBackground)}>
              <Grid
                item
                xs={12}
                sm={12}
                xl={12}
                md={12}
                lg={12}
                id={ScrollOptions.PRICING_PLAN}
                className={classNames(classes.productsBoxGrid)}
              >
                <ProductsBox changeWidthProp={true} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                xl={12}
                md={12}
                lg={12}
                className={classNames(classes.freeButtonGrid, {
                  mobile: isMobile,
                })}
              >
                <SimpleButton
                  primary
                  text={intl.formatMessage({
                    id: I18nKey.LANDING_PAGE_MAIN_SECTION_TRY_FREE,
                  })}
                  onClick={handleSignUp}
                  className={classNames(classes.signUpBtn, {
                    mobile: isMobile,
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                <Box
                  className={classNames(classes.freeTrialHolder, {
                    mobile: isMobile,
                  })}
                >
                  <Typography
                    className={classNames(classes.monthFree, {
                      mobile: isMobile,
                    })}
                  >
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_FREE_TRIAL,
                    })}
                  </Typography>
                  <Typography
                    className={classNames(classes.noCreditCard, {
                      mobile: isMobile,
                    })}
                  >
                    &nbsp;
                    {intl.formatMessage({
                      id: I18nKey.LANDING_PAGE_MAIN_SECTION_NO_CARD,
                    })}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default LandingPageMainSection;
function setOpenTourGuide(arg0: boolean) {
  throw new Error("Function not implemented.");
}
